import { render, staticRenderFns } from "./CrmToolbar.vue?vue&type=template&id=8b520d8e&scoped=true&"
import script from "./CrmToolbar.vue?vue&type=script&lang=js&"
export * from "./CrmToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CrmToolbar.vue?vue&type=style&index=0&id=8b520d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b520d8e",
  null
  
)

export default component.exports